module.exports = __webpack_public_path__ + "static/media/select-arrow.605e1df9.svg";